export enum MessageType {
    Welcome = 0,
    Regular = 1,
    Error = 2,
}